import { Path } from "./grid";
import { Resource } from "./resource";

export type Unit = {
  id: number;
  position: Coord;
  destination: Coord;
  taskStack: TASKS[];
  path: Path;
  hp: number;
  damage: number;
  defence: number;
  ticksToMove: number;
  ticksToGather: number;
  currentTick: number;
  resource: Resource;
  repoPathTraced: boolean;
};

type Coord = {
  x: number;
  y: number;
};

export enum TASKS {
  MOVE = "MOVE",
  FIGHT = "FIGHT",
  GATHER_RESOURCE = "GATHER_RESOURCE",
  DEPOSIT_RESOURCE = "DEPOSIT_RESOURCE",
};

export const GatherResourceTaskList = [
    TASKS.DEPOSIT_RESOURCE,
    TASKS.MOVE,
    TASKS.GATHER_RESOURCE,
    TASKS.MOVE,
];